// extracted by mini-css-extract-plugin
module.exports = {"masonryGrid":"_928d48f8"};